import {
	PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY,
	PRODUCT_DISCOVERY_TEAM_MANAGED_KEY,
	PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY,
} from '@atlassian/jira-common-constants/src/project-template-type-keys.tsx';

import { TEMPLATE_KEY as PRIORITIZATION_KEY } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/prioritization/index.tsx';
import { TEMPLATE_KEY as PRODUCT_ROADMAP_KEY } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/product-roadmap/index.tsx';
import { TEMPLATE_KEY as PRODUCT_DISCOVERY_KEY } from '@atlassian/jira-project-template-select-v2/src/utils/templates/product-discovery/product-discovery/index.tsx';
import type { TemplateKey } from '../types.tsx';

const templateKeyToTmpKey = {
	[PRODUCT_DISCOVERY_KEY]: PRODUCT_DISCOVERY_TEAM_MANAGED_KEY,
	[PRODUCT_ROADMAP_KEY]: PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY,
	[PRIORITIZATION_KEY]: PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY,
};

export const getTemplateTmpKeyFromKey = (templateKey: TemplateKey): string => {
	return templateKeyToTmpKey[templateKey];
};
